<script>
import productCardMixin from '@/v-shop/mixins/product-card-mixin'
import shopProductOptions from '@/v-shop/mixins/shop-product-options-mixin'

export default {
	lang: 'shop',
	mixins: [productCardMixin, shopProductOptions],
	cssVars: {
		selector: '.product-card',
	},
}
</script>

<template>
	<!--  VERTICAL CARD -->
	<div
		v-if="verticalCard"
		:class="['h100', smallWrapperClass]"
		v-click-outside="forMobileShop && onLinkBlurMobile"
	>
		<v-hover v-model="hover">
			<v-card
				:hover="!outOfStock"
				elevation="2"
				@click="cardClick"
				:ripple="false"
				:class="[
					'd-flex flex-column rounded-md overflow-hidden base product-card',
					$bem('product-card-design6-small'),
					alignment == 'left' ? 'text-start' : alignment == 'center' ? 'text-center' : 'text-end',
					{ 'card-border': cardBorder },
				]"
				:style="{ height: forMobileShop && hasHoverAction && hover ? 'calc(100% + 50px)' : '100%' }"
			>
				<ProductCard-FinancingTag />

				<div :class="[$bem('__image-cont'), { 'no-stock': outOfStock }]">
					<Media
						cover
						:class="$bem('__main-image')"
						:src="mainImage"
						width="100%"
						:imgClass="
							$b.mt
								? 'product-card-design6-small__image--smallWidth-mobile'
								: 'product-card-design6-small__image--smallWidth'
						"
					/>
					<div v-if="secondImage && hover && imgHover" :class="$bem('__second-image-cont')">
						<Media
							cover
							:src="secondImage"
							width="100%"
							:class="[$bem('__second-image'), hover ? $bem('__second-image--show') : '']"
							:imgClass="
								$b.mt
									? 'product-card-design6-small__image--smallWidth-mobile'
									: 'product-card-design6-small__image--smallWidth'
							"
						/>
					</div>

					<LimitedTimeOffer :product="product" v-if="hasLimitedTimeOffer" :class="$bem('__offer')" />

					<CollectionEventIcon :product="product" :class="$bem('__event-icon')" imgWidth="25px" />
				</div>

				<div
					:class="[
						$bem('__data-cont'),
						'd-flex flex-column mx-2',
						{
							'no-stock': outOfStock,
							h100: hasVisibleAction,
						},
					]"
					style="gap: 6px"
				>
					<ProductCardPrice
						:class="$bem('__price-container')"
						:product="product"
						:currency="currency"
						:priceAmount="price"
						:prevPriceAmount="prevPrice"
						:discountPct="discountPct"
						:containerClass="[
							$bem('__prev-price'),
							'd-flex align-baseline pb-1 line-clamp-1 px-1',
							{ 'justify-center': alignment == 'center', 'justify-end': alignment == 'right' },
						]"
						prevPriceClass="grey--text font-0"
						:priceClass="[
							$bem('__price'),
							'price font-3 line-clamp-1  mt-2 px-1',
							{
								'text-center': alignment == 'center',
								'text-end': alignment == 'right',
							},
						]"
						:discountClass="[$bem('__discount'), 'd-inline-block discount font-0 ml-1']"
						prevPriceGroup
					/>

					<ProductCard-TextTag />

					<ProductCard-Tags class="font-0" />

					<ProductCard-AttrsTags />

					<router-link :to="productRoute" custom v-slot="{ navigate, href }">
						<a
							class="card-anchor header"
							@click="forMobileShop ? onLinkClickMobile(navigate, $event) : navigate($event)"
							:href="href"
						>
							<div :class="[$bem('__name'), 'line-clamp-2 font-1 header px-1']">
								{{ product.name }}
							</div>
						</a>
					</router-link>

					<ProductCard-VariantSelector />

					<div
						v-if="brand"
						:class="[$bem('__brand'), 'font-0 line-clamp-1 px-1', { 'mb-2': !mobileBtn }]"
					>
						{{ brand }}
					</div>

					<ProductCardRating :product="product" />

					<v-spacer />

					<ProductCard-Actions />
				</div>
			</v-card>
		</v-hover>
	</div>
	<!-- END OF VERTICAL CARD -->

	<!-- HORIZONTAL CARD -->
	<div
		v-else
		:class="[
			'w100 product-card--horizontal',
			{
				'product-card-design6-small-horizontal-wrapper-forBtn': hasHoverAction,
				'product-card--align-right': alignment == 'right',
				'product-card--align-center': alignment == 'center',
			},
		]"
		v-click-outside="forMobileShop && onLinkBlurMobile"
	>
		<v-hover v-model="hover">
			<v-card
				:hover="!outOfStock"
				outlined
				@click="cardClick"
				:ripple="false"
				:class="[
					'd-flex overflow-hidden base product-card py-2',
					$bem('product-card-design6-small-horizontal'),
					{ 'product-card-design6-small-horizontal-forBtn': hasAction, 'card-border': cardBorder },
				]"
			>
				<div
					:class="[
						$bem('__image-cont', 'col col-5 pa-0 d-flex flex-column justify-center'),
						{ 'no-stock': outOfStock },
					]"
				>
					<div class="h100 p-relative">
						<Media
							:class="$bem('__main-image', 'px-1 h100')"
							:src="mainImage"
							width="100%"
							imgClass="product-card-design6-small-horizontal__image--smallWidth"
						/>
						<div v-if="secondImage && hover && imgHover" :class="$bem('__second-image-cont', 'h100')">
							<Media
								:src="secondImage"
								width="100%"
								:class="[
									$bem('__second-image', 'h100'),
									hover ? $bem('__second-image--show') : '',
									'h100',
								]"
								imgClass="product-card-design6-small-horizontal__image--smallWidth"
							/>
						</div>
					</div>

					<LimitedTimeOffer
						:product="product"
						textAlign="start"
						class="mx-2 rounded line-clamp-1 font-weight-regular"
						style="width: inherit; padding: 0 4px !important"
					/>
				</div>

				<div
					class="col col-7 py-0 pl-1 flex-column mt-2"
					:class="[
						$bem('__data-cont'),
						{
							'no-stock': outOfStock,
							h100: $b.m && !forMobileShop,
						},
					]"
				>
					<ProductCard-AttrsTags :vertical-card="false" />

					<ProductCardPrice
						:class="$bem('__price-container')"
						:product="product"
						:currency="currency"
						:priceAmount="price"
						:prevPriceAmount="prevPrice"
						:discountPct="discountPct"
						:containerClass="[$bem('__prev-price'), 'd-flex align-center pb-2 line-clamp-1']"
						prevPriceClass="grey--text font-0"
						:priceClass="[$bem('__price'), 'price font-4 line-clamp-1 mt-1', { 'mt-3': hasAction }]"
						:discountClass="[$bem('__discount'), 'd-inline-block discount font-0']"
						prevPriceGroup
						horizontalCard
					/>

					<ProductCard-TextTag />

					<ProductCard-Tags class="font-0" />

					<router-link :to="productRoute" custom v-slot="{ navigate, href }">
						<a
							class="card-anchor header"
							@click="forMobileShop ? onLinkClickMobile(navigate, $event) : navigate($event)"
							:href="href"
						>
							<div :class="[$bem('__name'), 'line-clamp-2 font-2 header', ,]">{{ product.name }}</div>
						</a>
					</router-link>

					<ProductCard-VariantSelector />

					<div v-if="brand" :class="[$bem('__brand'), 'font-0 line-clamp-1']">{{ brand }}</div>

					<ProductCardRating :product="product" />

					<v-spacer />

					<ProductCard-Actions />

					<ProductCard-FinancingTag />

					<CollectionEventIcon :product="product" :class="$bem('__event-icon')" imgWidth="30px" />
				</div>
			</v-card>
		</v-hover>
	</div>
	<!-- END OF HORIZONTAL CARD -->
</template>

<style lang="scss" scoped>
.cardBorder {
	border: 1px solid #b2b2b2;
}
.no-stock {
	opacity: 0.4;
}

// VERTICAL CARD CLASSES
.product-card-design6-small-wrapper {
	// min-height: 270px;
	width: 100%;
	min-width: 100px;

	&-forBtn {
		// min-height: 270px;
		width: 100%;
		min-width: 100px;
		padding-bottom: 50px;
	}
}

.product-card-design6-small-wrapper-mobile {
	width: 90%;

	&-forBtn {
		width: 90%;
	}
}

.product-card-design6-small {
	position: relative;
	cursor: pointer;

	&__image-cont {
		position: relative;
	}

	&__second-image-cont {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	&__second-image {
		transition: opacity 0.3s;
		opacity: 0;
		&--show {
			opacity: 1;
		}
	}

	&__offer {
		position: absolute;
		bottom: 0;
	}

	&__event-icon {
		position: absolute;
		top: 60%;
		right: 5px;
		z-index: 1;
		width: 25px;
	}

	&__discount {
		padding: 2px 5px;
		border-radius: 4px;
	}

	&__name,
	&__brand {
		display: -webkit-box;
	}
}

::v-deep .product-card-design6-small {
	.alignment-center {
		position: relative;
		left: 50%;
		transform: translateX(-50%);
	}

	.alignment-right {
		float: right;
	}

	&__discount {
		padding: 2px 5px;
		border-radius: 4px;
	}

	&__price {
		display: -webkit-box;
	}

	&__image--smallWidth {
		width: 100%;
		height: 100%;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
	}

	&__image--smallWidth-mobile {
		width: 100%;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
	}
}

// HORIZONTAL CARD CLASSES
.product-card-design6-small-horizontal {
	// height: 200px;

	// &-forBtn {
	// 	height: 240px;
	// }

	height: 100%;

	&__image-cont {
		position: relative;
		width: 200px;
	}

	&__second-image-cont {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
	}

	&__second-image {
		transition: opacity 0.3s;
		opacity: 0;
		&--show {
			opacity: 1;
		}
	}

	.product-card__financing-wrapper {
		position: absolute;
		top: 5px;
	}

	&__event-icon {
		position: absolute;
		top: 4px;
		right: 10px;
		z-index: 1;
		width: 25px;
	}

	&__name,
	&__brand {
		display: -webkit-box;
	}
}

::v-deep div.product-card-design6-small-horizontal {
	&__image--smallWidth {
		width: 80%;
		left: 50%;
		transform: translateX(-50%);
		height: auto;
	}

	&__prev-price {
		display: -webkit-box;
		column-gap: 8px;
	}

	&__discount {
		padding: 2px 5px;
		border-radius: 4px;
	}

	&__price {
		display: -webkit-box;
	}
}
</style>

